import axios from 'axios'
// import Vue from 'vue'

export const API_AD = axios.create({
  baseURL: `https://plan.wydawnictwowam.pl/api`,
  auth: {username: `token`, password: `m2TIVfpgg&PR%kb50^H`},
  withCredentials: true
})

export const API_EC = axios.create({
  baseURL: `https://wydawnictwowam.pl/json`,
  withCredentials: false
})



// WEBPACK FOOTER //
// ./src/axios.js